import { collection, getDocs, query, where } from 'firebase/firestore'
import { firebaseDb } from './init'
import {
  IGenericError,
  IPracticeQuestion,
  IPracticeQuestionRaw,
} from '../types'
import { QuerySnapshot } from 'firebase-admin/firestore'

const practiceQuestionsCollectionRef = collection(
  firebaseDb,
  'practiceQuestions',
)

export async function getPracticeQuestions(
  topicName: string,
  lessonTitle: string,
  mmrVariant: number,
): Promise<IPracticeQuestion[]> {
  try {
    const q = query(
      practiceQuestionsCollectionRef,
      where('title', '==', lessonTitle),
      where('topicName', '==', topicName),
      where('mmr', '==', mmrVariant.toString()),
    )

    const querySnapshot = (await getDocs(
      q,
    )) as unknown as QuerySnapshot<IPracticeQuestionRaw>

    const practiceQuestions: IPracticeQuestion[] = []

    querySnapshot.docs.forEach((doc) => {
      const practiceQuestion: IPracticeQuestion = {
        ...doc.data(),
        id: doc.id,
      }

      practiceQuestions.push(practiceQuestion)
    })

    return practiceQuestions
  } catch (error: unknown) {
    console.error(
      `error while trying to get practice questions, topicName: ${topicName}, lessonTitle: ${lessonTitle}, mmrVariant: ${mmrVariant} :>> `,
      (error as IGenericError)?.message || error,
    )

    throw new Error(
      (error as IGenericError)?.message ||
        `Unexpected error while trying to get practice questions`,
    )
  }
}
